import React from 'react';
import { Stack, Typography } from '@mui/material';
import cx from 'classnames';
import { DatasetHeaderProps } from './types';
import styles from './DatasetHeader.module.scss';

/**
 * Reusable header component for displaying dataset name and description.
 * Used in drawers, modals, and detail views to provide consistent dataset information display.
 */
export const DatasetHeader = ({ name, description, className }: DatasetHeaderProps) => {
  return (
    <header className={cx(styles.header, className)}>
      <Stack gap="4px">
        <Typography component="h2" variant="bodyLarge">
          {name}
        </Typography>
        {description && (
          <Typography component="p" variant="bodyLarge" color="text.secondary">
            {description}
          </Typography>
        )}
      </Stack>
    </header>
  );
};
